<template>
  <section class="m-1 mt-4 mb-4" v-if="show">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="title ml-3 pb-1 d-flex align-items-center">
        <svg
          @click="$emit('back')"
          class="pointer mr-4 mb-1"
          width="16"
          height="16"
          viewBox="0 1 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.828 7.00066H16V9.00066H3.828L9.192 14.3647L7.778 15.7787L0 8.00066L7.778 0.222656L9.192 1.63666L3.828 7.00066Z"
            fill="#565E73"
          />
        </svg>
        <div class="subtitle">
          <div class="subtitle-neighborhood">
            {{ relatoryKeepingSector.neighborhoodName }}
          </div>
          <div class="subtitle-keeping">
            {{ relatoryKeepingSector.keepingSectorName }}
          </div>
        </div>
      </h1>
      <span class="pointer btn-relatory mr-2 mb-3" @click="redirectToPrint">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="28" height="28" rx="14" fill="#003063" />
          <path
            d="M11.5 16.5H16.5V19H11.5V16.5ZM17.5 18V15.5H10.5V18H9.5C9.36739 18 9.24021 17.9473 9.14645 17.8536C9.05268 17.7598 9 17.6326 9 17.5V12.5C9 12.3674 9.05268 12.2402 9.14645 12.1464C9.24021 12.0527 9.36739 12 9.5 12H18.5C18.6326 12 18.7598 12.0527 18.8536 12.1464C18.9473 12.2402 19 12.3674 19 12.5V17.5C19 17.6326 18.9473 17.7598 18.8536 17.8536C18.7598 17.9473 18.6326 18 18.5 18H17.5ZM10.5 13V14H12V13H10.5ZM11.5 9H16.5C16.6326 9 16.7598 9.05268 16.8536 9.14645C16.9473 9.24021 17 9.36739 17 9.5V11H11V9.5C11 9.36739 11.0527 9.24021 11.1464 9.14645C11.2402 9.05268 11.3674 9 11.5 9Z"
            fill="white"
          />
        </svg>
      </span>
    </div>

    <div v-if="userType !== 2" class="d-flex flex-column ml-3 mb-4">
      <span
        ><svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.33337 12.334V9.00065H5.66671V12.334H11.6667V7.66732H2.33337V12.334H4.33337ZM1.66671 6.33398H12.3334V4.33398H8.33337V1.66732H5.66671V4.33398H1.66671V6.33398ZM1.00004 13.0007V7.66732H0.333374V3.66732C0.333374 3.49051 0.403612 3.32094 0.528636 3.19591C0.65366 3.07089 0.82323 3.00065 1.00004 3.00065H4.33337V1.00065C4.33337 0.82384 4.40361 0.654271 4.52864 0.529246C4.65366 0.404222 4.82323 0.333984 5.00004 0.333984H9.00004C9.17685 0.333984 9.34642 0.404222 9.47145 0.529246C9.59647 0.654271 9.66671 0.82384 9.66671 1.00065V3.00065H13C13.1769 3.00065 13.3464 3.07089 13.4714 3.19591C13.5965 3.32094 13.6667 3.49051 13.6667 3.66732V7.66732H13V13.0007C13 13.1775 12.9298 13.347 12.8048 13.4721C12.6798 13.5971 12.5102 13.6673 12.3334 13.6673H1.66671C1.4899 13.6673 1.32033 13.5971 1.1953 13.4721C1.07028 13.347 1.00004 13.1775 1.00004 13.0007Z"
            fill="#565E73"
          />
        </svg>
        <span
          class="user-details hover-user pointer"
          @click="redirect(userData)"
          >{{ userData.name ? userData.name : "Não informado" }}
          <svg
            v-if="userData.name"
            class="user-icon"
            width="12"
            height="12"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 2V3H1.5V8.5H7V6H8V9C8 9.13261 7.94732 9.25979 7.85355 9.35355C7.75979 9.44732 7.63261 9.5 7.5 9.5H1C0.867392 9.5 0.740215 9.44732 0.646447 9.35355C0.552678 9.25979 0.5 9.13261 0.5 9V2.5C0.5 2.36739 0.552678 2.24021 0.646447 2.14645C0.740215 2.05268 0.867392 2 1 2H4ZM9.5 0.5V5L7.603 3.1035L4.6035 6.1035L3.8965 5.3965L6.896 2.3965L5 0.5H9.5Z"
              fill="#00B1EB"
            />
          </svg> </span
      ></span>
      <span class="icon-delay" v-if="userData.phone"
        ><svg
          width="10"
          height="14"
          viewBox="0 0 10 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.66671 1.66732V12.334H8.33337V1.66732H1.66671ZM1.00004 0.333984H9.00004C9.17685 0.333984 9.34642 0.404222 9.47145 0.529246C9.59647 0.654271 9.66671 0.82384 9.66671 1.00065V13.0007C9.66671 13.1775 9.59647 13.347 9.47145 13.4721C9.34642 13.5971 9.17685 13.6673 9.00004 13.6673H1.00004C0.82323 13.6673 0.653661 13.5971 0.528636 13.4721C0.403612 13.347 0.333374 13.1775 0.333374 13.0007V1.00065C0.333374 0.82384 0.403612 0.654271 0.528636 0.529246C0.653661 0.404222 0.82323 0.333984 1.00004 0.333984ZM5.00004 10.334C5.17685 10.334 5.34642 10.4042 5.47145 10.5292C5.59647 10.6543 5.66671 10.8238 5.66671 11.0007C5.66671 11.1775 5.59647 11.347 5.47145 11.4721C5.34642 11.5971 5.17685 11.6673 5.00004 11.6673C4.82323 11.6673 4.65366 11.5971 4.52864 11.4721C4.40361 11.347 4.33337 11.1775 4.33337 11.0007C4.33337 10.8238 4.40361 10.6543 4.52864 10.5292C4.65366 10.4042 4.82323 10.334 5.00004 10.334Z"
            fill="#565E73"
          />
        </svg>
        <span class="user-details pl-1">{{
          formatPhone(userData.phone)
        }}</span></span
      >
    </div>

    <div class="date-info">
      <div class="mb-2 d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div class="mr-3">
            <span
              @click="starFilterModal = true"
              class="pointer pt-1"
              id="star-btn"
              ><svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="28" height="28" rx="14" fill="#003063" />
                <g clip-path="url(#clip0_6291_316877)">
                  <path
                    d="M14.0034 17.13L10.4769 19.104L11.2644 15.14L8.29688 12.396L12.3104 11.92L14.0034 8.25L15.6964 11.92L19.7099 12.396L16.7424 15.14L17.5299 19.104L14.0034 17.13Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_6291_316877">
                    <rect
                      width="12"
                      height="12"
                      fill="white"
                      transform="translate(8 8)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <Transition name="filter">
              <div v-if="starFilterModal" class="star-filter" id="star">
                <div class="d-flex justify-content-between">
                  <p class="checkbox-title">Filtrar por avaliação</p>
                  <svg
                    @click="starFilterModal = false"
                    class="pointer star-close"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.99681 5.58574L11.9468 0.635742L13.3608 2.04974L8.41081 6.99974L13.3608 11.9497L11.9468 13.3637L6.99681 8.41374L2.04681 13.3637L0.632812 11.9497L5.58281 6.99974L0.632812 2.04974L2.04681 0.635742L6.99681 5.58574Z"
                      fill="#B0B4BD"
                    />
                  </svg>
                </div>
                <ul>
                  <li
                    v-for="star in starsData"
                    :key="star.value"
                    class="d-flex align-items-center list-item mb-3"
                  >
                    <input
                      class="mr-2 input-checkbox"
                      type="checkbox"
                      :checked="star.selected"
                      :name="star.label"
                      v-model="star.selected"
                    />
                    <label
                      class="d-flex align-items-center checkbox-label m-0"
                      :for="star.label"
                    >
                      <span
                        style="color: #fdc640"
                        class="material-icons-outlined mr-2"
                        >star</span
                      >{{ star.label }}
                    </label>
                  </li>
                </ul>
                <PrimaryButton
                  @clicked="filterByStars"
                  name="Filtrar Resultados"
                  class="mt-2 w-100"
                />
              </div>
            </Transition>
          </div>
          <span
            @click="filterModal = !filterModal"
            class="pointer mr-3"
            id="filter-btn"
            ><svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="28" height="28" rx="14" fill="#003063" />
              <path
                d="M18.5 10V11H18L15 15.5V19H13V15.5L10 11H9.5V10H18.5Z"
                fill="white"
              />
            </svg>
          </span>
          <Transition name="filter">
            <div
              style="width: fit-content"
              class="absolute-box"
              v-if="filterModal"
              id="filter"
            >
              <CheckboxFilter
                @clicked="filterModal = !filterModal"
                @filter-by-activity="filterByActivity"
                :activitiesData="relatoryKeepingSector.activities"
                name="Filtre por Atividade"
              />
            </div>
          </Transition>
          <span
            @click="calendarModal = !calendarModal"
            class="pointer mr-3"
            id="calendar-btn"
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="28" height="28" rx="14" fill="#003063" />
              <path
                d="M9 13.5H19V18C19 18.1326 18.9473 18.2598 18.8536 18.3536C18.7598 18.4473 18.6326 18.5 18.5 18.5H9.5C9.36739 18.5 9.24021 18.4473 9.14645 18.3536C9.05268 18.2598 9 18.1326 9 18V13.5ZM16.5 9.5H18.5C18.6326 9.5 18.7598 9.55268 18.8536 9.64645C18.9473 9.74021 19 9.86739 19 10V12.5H9V10C9 9.86739 9.05268 9.74021 9.14645 9.64645C9.24021 9.55268 9.36739 9.5 9.5 9.5H11.5V8.5H12.5V9.5H15.5V8.5H16.5V9.5Z"
                fill="white"
              />
            </svg>
          </span>
          <Transition name="filter">
            <div class="calendar-box w-100" v-if="calendarModal" id="calendar">
              <div>
                <v-date-picker v-model="range" is-range>
                  <template v-slot:footer>
                    <div class="d-flex justify-content-between mt-3">
                      <button
                        class="mb-3 w-100 ml-2 cancel-button"
                        @click="calendarModal = !calendarModal"
                      >
                        {{ $t("cancel") }}
                      </button>
                      <button
                        class="mb-3 mr-2 ml-2 w-100 send-button"
                        @click="sendDates"
                      >
                        {{ $t("filter") }}
                      </button>
                    </div>
                  </template>
                </v-date-picker>
              </div>
            </div>
          </Transition>
          <DateLabel :name="lastDaysButtonLabel" class="no-pointer mt-1" />
        </div>
      </div>
    </div>

    <section class="cycles-container">
      <Cycles
        :dates="dates"
        :keepingSectorId="relatoryKeepingSector.keepingSectorId"
        @send-dates="handleMonthChange"
      />
    </section>

    <div class="map-info">
      <div class="map-info-container">
        <div class="map-info-box map-width-reduced">
          <div class="map-info-counters">
            <div class="map-info-text">{{ $t("executions") }}</div>
            <div class="map-info-counter">
              {{
                relatoryKeepingSector.executions
                  ? relatoryKeepingSector.executions.length
                  : 0
              }}
            </div>
          </div>
          <div>
            <svg
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.1721 27.2773L16.9602 25.969C16.6146 25.5959 16.032 25.5736 15.6589 25.9192L15.5367 26.0325C15.1636 26.3781 15.1413 26.9607 15.4869 27.3338L16.6988 28.6421C17.0444 29.0152 17.627 29.0374 18.0001 28.6918L18.1224 28.5786C18.4955 28.233 18.5177 27.6504 18.1721 27.2773Z"
                fill="#5CCDF2"
              />
              <path
                d="M28.5625 24.5C30.461 24.5 32 22.961 32 21.0625C32 19.164 30.461 17.625 28.5625 17.625C26.664 17.625 25.125 19.164 25.125 21.0625C25.125 22.961 26.664 24.5 28.5625 24.5Z"
                fill="#5C7B9B"
              />
              <path
                d="M19.1667 30.7752C19.7723 30.8147 20.3802 30.8008 20.9833 30.7336L21.5833 30.6377H21.6167C24.8625 30.0127 27.375 28.1377 29.0875 25.1044C30.7542 22.1336 30.9292 18.7586 29.6 14.7877C29.5055 14.4358 29.3234 14.1136 29.0705 13.8513C28.8176 13.589 28.5024 13.3951 28.1542 13.2877C27.7955 13.2133 27.4238 13.2313 27.074 13.3399C26.7242 13.4485 26.4077 13.6442 26.1542 13.9086C25.3827 14.6732 24.3842 15.1674 23.3083 15.3169C22.1375 15.4586 20.95 15.5252 19.8042 15.5919H19.5667C18.2577 15.6006 16.9706 15.9281 15.8167 16.5461C12.6458 18.4336 10.75 22.5252 13.25 26.7044C13.311 26.8042 13.3639 26.9087 13.4083 27.0169L13.5292 27.3127L13.3542 27.5752C12.8996 28.2749 12.4823 28.9981 12.1042 29.7419C12.0899 29.7733 12.0825 29.8074 12.0825 29.8419C12.0825 29.8764 12.0899 29.9105 12.1042 29.9419C12.1139 29.9746 12.1304 30.0049 12.1527 30.0307C12.175 30.0566 12.2024 30.0774 12.2333 30.0919C12.2637 30.1077 12.2968 30.1173 12.3309 30.1202C12.365 30.1231 12.3993 30.1192 12.4319 30.1088C12.4644 30.0983 12.4946 30.0815 12.5206 30.0593C12.5466 30.0371 12.5679 30.0099 12.5833 29.9794C13.3231 28.5105 14.232 27.133 15.2917 25.8752L15.7083 25.3794L16.1667 25.8461C16.4 26.0836 16.6917 26.3877 16.9667 26.6794C17.0171 26.7313 17.086 26.7612 17.1583 26.7627C17.2251 26.7635 17.2894 26.7381 17.3375 26.6919C17.3882 26.644 17.4181 26.5782 17.4208 26.5086C17.4221 26.4742 17.4165 26.4399 17.4044 26.4077C17.3922 26.3755 17.3737 26.346 17.35 26.3211C16.9792 25.9252 16.7125 25.6461 16.5167 25.4419L16.1 24.9961L16.5542 24.5794C17.2312 23.9458 17.968 23.3793 18.7542 22.8877C19.7671 22.2239 20.8991 21.7626 22.0875 21.5294C22.1569 21.52 22.2198 21.4838 22.2627 21.4284C22.3056 21.3731 22.325 21.3031 22.3167 21.2336C22.3126 21.1995 22.3017 21.1666 22.2848 21.1368C22.2679 21.107 22.2451 21.0809 22.218 21.0599C22.1908 21.039 22.1598 21.0237 22.1267 21.0148C22.0935 21.006 22.059 21.0039 22.025 21.0086C20.7731 21.2385 19.5801 21.7174 18.5167 22.4169L17.575 22.9919V21.8877C17.575 21.6836 17.575 21.4711 17.575 21.2836C17.5755 21.2489 17.5691 21.2145 17.5563 21.1823C17.5434 21.1501 17.5243 21.1208 17.5 21.0961C17.4519 21.0457 17.3862 21.0159 17.3167 21.0127C17.2478 21.0116 17.1812 21.0376 17.1313 21.0852C17.0814 21.1327 17.0522 21.198 17.05 21.2669C17.0167 22.3086 17.0125 22.8252 17.05 23.1044V23.4127L16.8125 23.6086C15.9392 24.3415 15.1408 25.1594 14.4292 26.0502L13.9042 26.7336L13.4667 25.9544C12.9868 25.0621 12.7218 24.0702 12.6929 23.0574C12.664 22.0447 12.8719 21.0393 13.3 20.1211C13.6874 19.2057 14.2875 18.3959 15.0506 17.7589C15.8137 17.1219 16.7176 16.6762 17.6875 16.4586C18.6501 16.2808 19.6255 16.1818 20.6042 16.1627L21.3375 16.1294C23.1375 16.0252 25.0042 15.7461 26.45 14.3877C27.125 13.7544 27.7 13.7419 28.0375 13.8461C28.375 13.9502 28.8708 14.2627 29.0792 15.1502C29.4088 16.3315 29.647 17.5365 29.7917 18.7544C29.949 20.2081 29.7964 21.6787 29.344 23.0691C28.8915 24.4596 28.1494 25.7383 27.1667 26.8211C26.1745 27.8911 24.9686 28.7408 23.6271 29.3151C22.2855 29.8893 20.8383 30.1752 19.3792 30.1544H19.2875C19.2238 30.1536 19.1604 30.1634 19.1 30.1835C19.0705 30.1895 19.0422 30.2008 19.0167 30.2169C18.9786 30.2438 18.9474 30.2794 18.9257 30.3206C18.904 30.3619 18.8923 30.4077 18.8917 30.4544C18.8877 30.4937 18.8917 30.5334 18.9035 30.5711C18.9153 30.6088 18.9347 30.6438 18.9604 30.6738C18.9861 30.7038 19.0177 30.7282 19.0531 30.7457C19.0886 30.7631 19.1272 30.7732 19.1667 30.7752Z"
                fill="black"
              />
              <rect
                x="0.5"
                y="0.5"
                width="43"
                height="43"
                rx="21.5"
                stroke="#C6C9D0"
              />
            </svg>
          </div>
        </div>
        <div class="map-info-box map-width-reduced">
          <div class="map-info-counters">
            <div class="map-info-text">{{ $t("photos") }}</div>
            <div class="map-info-counter">
              {{ calculateQtdPhotos() }}
            </div>
          </div>
          <div>
            <svg
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5209 19.9292H14.0334C12.938 19.9292 12.05 20.8172 12.05 21.9125V28.1292C12.05 29.2246 12.938 30.1125 14.0334 30.1125H14.5209C15.6162 30.1125 16.5042 29.2246 16.5042 28.1292V21.9125C16.5042 20.8172 15.6162 19.9292 14.5209 19.9292Z"
                fill="#5CCDF2"
              />
              <path
                d="M27.2208 23.696C28.9582 23.696 30.3666 22.2875 30.3666 20.5501C30.3666 18.8127 28.9582 17.4043 27.2208 17.4043C25.4834 17.4043 24.075 18.8127 24.075 20.5501C24.075 22.2875 25.4834 23.696 27.2208 23.696Z"
                fill="#5C7B9B"
              />
              <path
                d="M30.3584 29.7831H30.6125C30.8221 29.7736 31.0268 29.717 31.2115 29.6174C31.3962 29.5179 31.556 29.378 31.6792 29.2081C31.8666 28.9464 31.9619 28.6299 31.95 28.3081C31.95 26.479 31.95 24.6248 31.95 22.829V19.9456C31.95 19.1123 31.95 18.279 31.95 17.4456C31.9558 17.1723 31.8795 16.9035 31.731 16.674C31.5824 16.4445 31.3684 16.2648 31.1167 16.1581C30.896 16.0641 30.656 16.0241 30.4167 16.0415H28.4375C28.2681 16.0608 28.0976 16.0166 27.959 15.9172C27.8204 15.8179 27.7236 15.6706 27.6875 15.504L27.55 15.1123V15.079L27.4167 14.7206C27.3491 14.4696 27.1969 14.2496 26.9858 14.0978C26.7748 13.946 26.5179 13.8716 26.2584 13.8873H23.025C22.7682 13.8726 22.5142 13.9477 22.3067 14.0998C22.0991 14.2518 21.9509 14.4713 21.8875 14.7206C21.8375 14.854 21.7917 14.9873 21.7459 15.1373L21.5834 15.579C21.5475 15.6922 21.4789 15.7922 21.3862 15.8663C21.2935 15.9405 21.1808 15.9855 21.0625 15.9956C20.8641 16.0061 20.6652 16.0061 20.4667 15.9956H20.125V15.704C20.125 15.5373 20.125 15.3831 20.125 15.229C20.1253 15.0249 20.0472 14.8286 19.9069 14.6805C19.7665 14.5324 19.5746 14.4438 19.3709 14.4331C18.625 14.4331 17.9 14.4331 17.0334 14.4331C16.926 14.4352 16.8204 14.4613 16.7245 14.5096C16.6286 14.558 16.5447 14.6272 16.4792 14.7123C16.4561 14.7326 16.4377 14.7576 16.425 14.7857C16.4124 14.8137 16.4058 14.8441 16.4058 14.8748C16.4058 14.9055 16.4124 14.9359 16.425 14.964C16.4377 14.992 16.4561 15.017 16.4792 15.0373C16.498 15.0593 16.5213 15.0769 16.5475 15.089C16.5738 15.1012 16.6024 15.1074 16.6313 15.1074C16.6602 15.1074 16.6888 15.1012 16.715 15.089C16.7413 15.0769 16.7646 15.0593 16.7834 15.0373C16.8535 14.9845 16.9336 14.9466 17.0188 14.9258C17.1041 14.9051 17.1927 14.9019 17.2792 14.9165H19.1292C19.2097 14.9108 19.2904 14.9108 19.3709 14.9165C19.4464 14.924 19.5169 14.9577 19.5701 15.0117C19.6234 15.0657 19.6561 15.1367 19.6625 15.2123C19.6625 15.3831 19.6625 15.554 19.6625 15.7331V16.029H15.9584C15.8062 16.023 15.6539 16.0342 15.5042 16.0623C15.1832 16.1299 14.8964 16.3086 14.6944 16.5671C14.4923 16.8255 14.3881 17.147 14.4 17.4748C14.4 19.5581 14.4 21.7248 14.4 23.7956V25.9831C14.3956 26.0275 14.3956 26.0721 14.4 26.1165C14.4091 26.1702 14.4373 26.2188 14.4794 26.2532C14.5216 26.2877 14.5748 26.3057 14.6292 26.304C14.6834 26.3065 14.7365 26.2887 14.7782 26.254C14.8198 26.2193 14.847 26.1702 14.8542 26.1165C14.8584 26.0554 14.8584 25.9942 14.8542 25.9331V20.1331C14.8542 19.254 14.8542 18.3456 14.8542 17.4498C14.8486 17.2154 14.931 16.9873 15.0853 16.8107C15.2396 16.634 15.4545 16.5216 15.6875 16.4956C15.7791 16.4894 15.871 16.4894 15.9625 16.4956H20.9084C21.1593 16.5123 21.4084 16.4418 21.6134 16.296C21.8184 16.1503 21.9667 15.9382 22.0334 15.6956C22.0834 15.5581 22.1292 15.4165 22.1792 15.279V15.2456C22.2209 15.1206 22.2625 14.9998 22.3084 14.879C22.3405 14.7249 22.4285 14.5881 22.5554 14.4951C22.6824 14.402 22.8392 14.3591 22.9959 14.3748H26.2834C26.4426 14.3529 26.6042 14.3911 26.7368 14.4821C26.8693 14.573 26.9632 14.71 27 14.8665C27.0375 14.979 27.0792 15.0873 27.1167 15.1998C27.1709 15.3623 27.2334 15.5456 27.3 15.7248C27.3581 15.9029 27.4617 16.0627 27.6006 16.1884C27.7394 16.3141 27.9087 16.4013 28.0917 16.4415C28.2095 16.466 28.3298 16.4758 28.45 16.4706H30.4917C30.6853 16.4559 30.8787 16.5028 31.044 16.6046C31.2094 16.7064 31.3384 16.8578 31.4125 17.0373C31.4753 17.1964 31.5064 17.3663 31.5042 17.5373C31.5042 20.2123 31.5042 22.954 31.5042 25.3915V27.4165C31.5042 27.7123 31.5042 28.0498 31.5042 28.3831C31.5088 28.6254 31.4186 28.8598 31.2528 29.0365C31.087 29.2132 30.8587 29.3182 30.6167 29.329C30.5125 29.329 30.4042 29.329 30.3 29.329H16.0875C15.9625 29.329 15.8167 29.329 15.6709 29.329C15.5599 29.3184 15.4523 29.2856 15.3542 29.2326C15.2562 29.1797 15.1697 29.1076 15.1 29.0206C14.993 28.8948 14.9178 28.7451 14.8808 28.5841C14.8438 28.4231 14.8461 28.2556 14.8875 28.0956V28.0415H15.75H16.7834C17.0681 28.0233 17.3351 27.8965 17.5289 27.6871C17.7228 27.4777 17.8288 27.2018 17.825 26.9165C17.825 25.729 17.825 24.5123 17.825 23.4373V23.3248C17.825 22.5248 17.825 21.729 17.825 20.929C17.8312 20.7823 17.8078 20.6359 17.7563 20.4984C17.7047 20.361 17.6261 20.2353 17.5251 20.1288C17.424 20.0223 17.3026 19.9372 17.168 19.8785C17.0335 19.8199 16.8885 19.7889 16.7417 19.7873C16.575 19.7873 16.4 19.7873 16.2292 19.7873H16.1667C16.1156 19.7898 16.065 19.7996 16.0167 19.8165C15.9729 19.833 15.9359 19.8637 15.9117 19.9038C15.8875 19.9438 15.8776 19.9909 15.8834 20.0373C15.8833 20.081 15.8981 20.1234 15.9254 20.1575C15.9526 20.1916 15.9907 20.2153 16.0334 20.2248C16.1026 20.2434 16.1742 20.2518 16.2459 20.2498H16.7334C16.8918 20.2547 17.0428 20.3184 17.1568 20.4286C17.2709 20.5387 17.3397 20.6874 17.35 20.8456C17.3541 20.9053 17.3541 20.9652 17.35 21.0248V26.704C17.348 26.7248 17.348 26.7457 17.35 26.7665C17.3542 26.8331 17.3542 26.8999 17.35 26.9665C17.3374 27.0946 17.2866 27.2159 17.2041 27.3148C17.1216 27.4136 17.0113 27.4853 16.8875 27.5206C16.7925 27.5461 16.6942 27.5573 16.5959 27.554H14.7334C14.475 27.554 14.4 27.629 14.4 27.8956V28.0081C14.4 28.1373 14.4 28.2706 14.4 28.404C14.4063 28.6699 14.4879 28.9285 14.6355 29.1498C14.783 29.3711 14.9903 29.5459 15.2334 29.654C15.4714 29.7492 15.7275 29.7905 15.9834 29.7748H30.3584V29.7831Z"
                fill="black"
              />
              <path
                d="M21.8043 18.0916C20.7594 18.6402 19.9288 19.5237 19.4456 20.6004C18.9625 21.6771 18.8546 22.8848 19.1394 24.0301C19.4241 25.1754 20.085 26.192 21.0162 26.9171C21.9474 27.6422 23.0949 28.0337 24.2751 28.0291C25.1786 28.0302 26.0671 27.7977 26.8543 27.3541C27.8181 26.8115 28.587 25.9797 29.0522 24.9762C29.5175 23.9728 29.6555 22.8485 29.4468 21.7623C29.2382 20.6761 28.6933 19.6829 27.8894 18.9233C27.0854 18.1637 26.063 17.6759 24.9668 17.5291C24.7306 17.4983 24.4924 17.4858 24.2543 17.4916C24.2235 17.4904 24.1928 17.4957 24.1642 17.507C24.1355 17.5184 24.1096 17.5356 24.088 17.5576C24.0664 17.5795 24.0497 17.6058 24.0389 17.6346C24.028 17.6634 24.0233 17.6942 24.0251 17.725C24.0228 17.7556 24.0266 17.7864 24.0363 17.8156C24.046 17.8448 24.0613 17.8718 24.0815 17.895C24.1016 17.9182 24.1261 17.9373 24.1536 17.951C24.1812 17.9647 24.2111 17.9729 24.2418 17.975C24.2819 17.9792 24.3224 17.9792 24.3626 17.975H24.3918C25.0935 17.9918 25.7826 18.1655 26.4084 18.4833C27.371 18.9648 28.1425 19.7577 28.5975 20.7332C29.0525 21.7086 29.1643 22.8092 28.9148 23.8562C28.6652 24.9032 28.0689 25.835 27.2229 26.5003C26.3768 27.1656 25.3306 27.5252 24.2543 27.5208C24.058 27.5226 23.8619 27.5129 23.6668 27.4916C22.5085 27.3447 21.4444 26.7778 20.6764 25.8984C19.9084 25.019 19.4898 23.8883 19.5001 22.7208C19.4999 21.8608 19.7361 21.0173 20.1829 20.2825C20.6297 19.5477 21.2698 18.9498 22.0334 18.5541L22.1126 18.5125C22.1603 18.4895 22.2063 18.463 22.2501 18.4333C22.3003 18.4029 22.3369 18.3544 22.3524 18.2978C22.3679 18.2412 22.3611 18.1809 22.3334 18.1291C22.3139 18.0882 22.2832 18.0536 22.2449 18.0292C22.2065 18.0049 22.1622 17.9919 22.1168 17.9916H22.0418C21.9721 18.0152 21.9051 18.0459 21.8418 18.0833L21.8043 18.0916Z"
                fill="black"
              />
              <path
                d="M27.8334 22.7123C27.8308 22.5435 27.8169 22.3751 27.7917 22.2081C27.7223 21.739 27.5583 21.2888 27.3098 20.8848C27.0613 20.4809 26.7333 20.1316 26.3459 19.8581C25.7395 19.419 25.0112 19.1801 24.2625 19.1748C24.0629 19.1747 23.8635 19.1915 23.6667 19.2248C22.8285 19.3774 22.0707 19.82 21.526 20.4752C20.9813 21.1303 20.6845 21.9562 20.6875 22.8081C20.6995 23.7447 21.0786 24.6392 21.7433 25.2992C22.4079 25.9592 23.305 26.3319 24.2417 26.3373H24.2667C25.1167 26.3333 25.9377 26.0277 26.5834 25.4748C26.8855 25.2284 27.1385 24.9273 27.3292 24.5873C27.3476 24.5605 27.3601 24.5302 27.3659 24.4982C27.3717 24.4662 27.3706 24.4334 27.3627 24.4018C27.3548 24.3703 27.3403 24.3408 27.3202 24.3153C27.3 24.2898 27.2747 24.2689 27.2459 24.254C27.1923 24.2217 27.1284 24.211 27.0672 24.2242C27.0061 24.2374 26.9522 24.2733 26.9167 24.3248C26.8917 24.3581 26.8709 24.3915 26.85 24.4248C26.8362 24.4493 26.8209 24.473 26.8042 24.4956C26.407 25.074 25.825 25.5001 25.1537 25.7039C24.4823 25.9077 23.7617 25.8771 23.11 25.6171C22.4584 25.3572 21.9145 24.8833 21.5678 24.2734C21.2211 23.6635 21.0921 22.9538 21.2021 22.2609C21.3121 21.5679 21.6545 20.9331 22.173 20.4605C22.6916 19.9879 23.3554 19.7057 24.0555 19.6603C24.7557 19.6149 25.4504 19.809 26.0256 20.2107C26.6008 20.6124 27.0223 21.1977 27.2209 21.8706C27.2738 22.0757 27.31 22.2847 27.3292 22.4956C27.3292 22.5748 27.3292 22.654 27.3584 22.7331C27.3834 22.9081 27.4834 23.0123 27.6167 23.004C27.6502 22.9994 27.6825 22.9882 27.7116 22.971C27.7408 22.9537 27.7662 22.9309 27.7864 22.9037C27.8065 22.8765 27.8211 22.8456 27.8292 22.8127C27.8372 22.7799 27.8387 22.7457 27.8334 22.7123Z"
                fill="black"
              />
              <path
                d="M25.7834 15.5039C25.7334 15.5039 23.5584 15.5039 23.5084 15.5039C23.4514 15.5102 23.3987 15.5376 23.3609 15.5808C23.3231 15.624 23.3029 15.6799 23.3043 15.7373C23.3028 15.7951 23.3229 15.8515 23.3606 15.8954C23.3983 15.9393 23.451 15.9676 23.5084 15.9748C23.5501 15.9748 25.7043 15.9748 25.7793 15.9748C25.8374 15.9671 25.8907 15.9386 25.9293 15.8945C25.968 15.8504 25.9893 15.7938 25.9893 15.7352C25.9893 15.6766 25.968 15.62 25.9293 15.5759C25.8907 15.5318 25.8374 15.5033 25.7793 15.4956L25.7834 15.5039Z"
                fill="black"
              />
              <path
                d="M30.1376 27.6124H28.9876C28.9323 27.6051 28.8762 27.6051 28.8209 27.6124C28.7745 27.627 28.7341 27.6566 28.7063 27.6966C28.6784 27.7365 28.6645 27.7845 28.6667 27.8332C28.6616 27.8833 28.673 27.9337 28.6994 27.9767C28.7258 28.0196 28.7655 28.0526 28.8126 28.0707C28.872 28.0887 28.9339 28.0971 28.9959 28.0957H30.1251C30.2386 28.102 30.3507 28.0681 30.4417 27.9999C30.4791 27.9558 30.4985 27.8993 30.4959 27.8415C30.4917 27.6957 30.3709 27.6124 30.1376 27.6124Z"
                fill="black"
              />
              <path
                d="M29.3791 26.3752C29.3768 26.4053 29.3805 26.4355 29.39 26.4642C29.3994 26.4929 29.4145 26.5194 29.4342 26.5423C29.454 26.5651 29.478 26.5838 29.505 26.5973C29.532 26.6108 29.5614 26.6189 29.5916 26.621C29.8206 26.6335 30.0501 26.6335 30.2791 26.621C30.3366 26.6169 30.3906 26.5917 30.4306 26.5501C30.4706 26.5085 30.4938 26.4536 30.4957 26.396C30.4981 26.3339 30.4765 26.2733 30.4354 26.2268C30.3942 26.1802 30.3368 26.1513 30.2749 26.146H29.5957C29.5382 26.1519 29.4846 26.1783 29.4449 26.2204C29.4051 26.2624 29.3818 26.3173 29.3791 26.3752Z"
                fill="black"
              />
              <path
                d="M17.4709 17.4165C17.277 17.4165 17.0875 17.474 16.9264 17.5818C16.7653 17.6896 16.6398 17.8428 16.5658 18.0219C16.4918 18.2011 16.4727 18.3982 16.5108 18.5882C16.5489 18.7783 16.6426 18.9528 16.78 19.0895C16.9173 19.2263 17.0922 19.3192 17.2824 19.3565C17.4726 19.3938 17.6696 19.3739 17.8485 19.2991C18.0273 19.2244 18.1799 19.0982 18.287 18.9366C18.3941 18.7751 18.4508 18.5853 18.45 18.3915C18.45 18.2631 18.4247 18.136 18.3754 18.0174C18.3262 17.8989 18.254 17.7912 18.163 17.7006C18.072 17.61 17.964 17.5383 17.8453 17.4895C17.7265 17.4408 17.5992 17.416 17.4709 17.4165ZM18.0459 18.3915C18.0467 18.5054 18.0137 18.617 17.951 18.7121C17.8883 18.8072 17.7988 18.8815 17.6938 18.9257C17.5888 18.9699 17.4731 18.9818 17.3613 18.9601C17.2494 18.9384 17.1466 18.884 17.0658 18.8037C16.9849 18.7235 16.9298 18.621 16.9072 18.5094C16.8847 18.3977 16.8958 18.2819 16.9392 18.1766C16.9826 18.0713 17.0563 17.9812 17.151 17.9179C17.2456 17.8545 17.357 17.8207 17.4709 17.8207C17.6205 17.8206 17.7643 17.8789 17.8717 17.9832C17.979 18.0874 18.0415 18.2294 18.0459 18.379V18.3915Z"
                fill="black"
              />
              <rect
                x="0.5"
                y="0.5"
                width="43"
                height="43"
                rx="21.5"
                stroke="#C6C9D0"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="filter-map">
      <div>
        <p class="activities-counter">
          {{ $t("showing") }}
          {{
            relatoryKeepingSector.executions
              ? relatoryKeepingSector.executions.length
              : 0
          }}
          {{
            relatoryKeepingSector.executions &&
            relatoryKeepingSector.executions.length === 1
              ? $t("oneExecution")
              : $t("moreExecutions")
          }}
        </p>
      </div>
    </div>

    <div class="list-container">
      <ActivitiesPhotosList
        ref="activitiesPhotos"
        :activitiesData="relatoryKeepingSector.executions"
        @hide-photos="hidePhotos"
        @show-photos="showPhotos"
        @filter-by-tag="filterByTag"
        :activitiesActiveCount="activitiesActiveCount"
      >
        <template v-slot:header>
          <div class="dates-info">
            <div class="dates-info__activity">
              Atividades de {{ formatDate(dates[0]) }} -
              {{ formatDate(dates[1]) }}
            </div>
            <div class="dates-info__time">
              <svg
                class="mr-1"
                width="12"
                height="13"
                viewBox="0 0 12 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0V1.33333C12 7.75133 8.418 10.6667 4 10.6667H2.732C2.87333 8.65867 3.49867 7.44333 5.13067 5.99933C5.93333 5.28933 5.86533 4.87933 5.47 5.11467C2.74733 6.73467 1.39533 8.924 1.33533 12.42L1.33333 12.6667H0C0 11.758 0.0773333 10.9333 0.230667 10.1787C0.0773333 9.316 0 8.14533 0 6.66667C0 2.98467 2.98467 0 6.66667 0C8 0 9.33333 0.666667 12 0Z"
                  fill="#29334E"
                />
              </svg>

              {{ relatoryKeepingSector.executions.length }}
              {{
                relatoryKeepingSector.executions.length === 1
                  ? "ATIVIDADE"
                  : "ATIVIDADES"
              }}
            </div>
          </div>
        </template>
      </ActivitiesPhotosList>
    </div>
  </section>
</template>

<script>
import { formatPhone } from "../../utils/phone";
import { formatMilisecondsToTime } from "../../utils/date";
import services from "../../services";
import ActivitiesPhotosList from "../ActivitiesPhotosList.vue";
import CheckboxFilter from "../CheckboxFilter.vue";
import Cycles from "./RelatoryKeepingSectorCycles.vue";
import PrimaryButton from "../../components/PrimaryButton.vue";
import DateLabel from "../../components/DateLabel.vue";

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    relatoryKeepingSector: {
      type: Object,
      required: true,
    },
    relatoryNeighborhood: {
      type: Object,
      required: true,
    },
    relatoryCity: {
      type: Object,
      required: true,
    },
    dates: {
      type: Array,
      required: true,
    },
    lastDaysButtonLabel: {
      type: String,
      required: true,
    },
    activeActivitiesFilter: {
      type: Array,
      required: true,
    },
    starsFilter: {
      type: Array,
      required: true,
    },
  },
  components: {
    ActivitiesPhotosList,
    CheckboxFilter,
    DateLabel,
    Cycles,
    PrimaryButton,
  },

  data() {
    return {
      userData: {
        name: "",
        phone: "",
        id: "",
      },
      starsData: [
        {
          label: "0/5",
          value: 0,
          selected: false,
        },
        {
          label: "1/5",
          value: 1,
          selected: false,
        },
        {
          label: "2/5",
          value: 2,
          selected: false,
        },
        {
          label: "3/5",
          value: 3,
          selected: false,
        },
        {
          label: "4/5",
          value: 4,
          selected: false,
        },
        {
          label: "5/5",
          value: 5,
          selected: false,
        },
      ],
      userType: null,
      filterModal: false,
      starFilterModal: false,
      calendarModal: false,
      checkAll: false,
      keepingSectorIncluded: true,
      filteredActivities: [],
      activitiesActiveCount: this.relatoryKeepingSector.activities.filter(
        (activity) => activity.active
      ).length,
      range: {
        start:
          this.dates[0] ||
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
          ).toISOString(),
        end: this.dates[1] || new Date().toISOString(),
      },
      pinsOff: false,
      heatmapOff: true,
      formatPhone,
      formatMilisecondsToTime,
    };
  },
  async mounted() {
    await this.getUserData();
    this.setIncluded();
    this.userType = this.$store.state.global.user.usuario_gestor_tipo_id;
    if (this.starsFilter) {
      this.starsFilter.forEach((item) => {
        this.starsData.map((star) => {
          if (item.value === star.value) {
            star.selected = true;
          }
        });
      });
    }
    document.addEventListener("click", (e) => {
      if (
        !e.target.closest("#calendar") &&
        !e.target.closest("#calendar-btn")
      ) {
        this.calendarModal = false;
      }

      if (!e.target.closest("#star") && !e.target.closest("#star-btn")) {
        this.starFilterModal = false;
      }

      if (!e.target.closest("#filter") && !e.target.closest("#filter-btn")) {
        this.filterModal = false;
      }
    });
  },
  methods: {
    async getUserData() {
      const { data, errors } =
        await services.keepingSectors.getDetailsKeepingSector({
          keepingSectorId: this.relatoryKeepingSector.keepingSectorId,
        });
      if (!errors) {
        this.userData.id = data[0].usuario_id;
        this.userData.name = data[0].usuario_nome;
        this.userData.phone = data[0].usuario_telefone;
      }
    },
    formatDate(date) {
      const dateArray = date.split("-");
      return `${dateArray[2].split("T")[0]}/${dateArray[1]}/${dateArray[0]}`;
    },
    setIncluded() {
      this.keepingSectorIncluded =
        this.relatoryKeepingSector.zeladoria_incluida === 1 ? true : false;
    },
    calculateQtdPhotos() {
      let counter = 0;
      if (this.relatoryKeepingSector.executions) {
        if (
          this.relatoryKeepingSector.executions &&
          this.relatoryKeepingSector.executions.length > 0
        ) {
          this.relatoryKeepingSector.executions.forEach((activity) => {
            if (activity.photos) {
              counter += activity.photos.length;
            }
          });
        }
      }
      return counter;
    },
    sendDates() {
      // checa se data está em format UTC para transformat em ISO
      let end = this.range.end.toString();
      let start = this.range.start.toString();

      if (start.includes("GMT") && end.includes("GMT")) {
        start = this.range.start.toISOString().slice(0, -5);
        end = this.range.end.toISOString().slice(0, -5);
      } else {
        start = this.range.start;
        end = this.range.end;
      }

      this.$emit("filter-by-date", {
        start,
        end,
      });
      this.calendarModal = false;
    },
    handleMonthChange(dates) {
      this.$emit("filter-by-date", {
        start: dates.start,
        end: dates.end,
      });
    },
    blockChooseDaysFromDifferentMonths() {
      this.range = {
        start: null,
        end: null,
      };
    },
    filterByTag(tags) {
      this.$emit("filter-by-tag", tags);
    },
    filterByStars() {
      const items = this.starsData.filter((star) => {
        return star.selected === true;
      });
      this.$emit("filter-by-stars", items);
    },
    showPhotos(activity) {
      this.$emit("show-photos", activity);
    },
    hidePhotos(activity) {
      this.$emit("hide-photos", activity);
    },
    redirectToPrint() {
      this.$store.dispatch("global/setPrintBackup", {
        dates: this.dates,
        relatoryKeepingSector: this.relatoryKeepingSector,
        relatoryNeighborhood: this.relatoryNeighborhood,
        relatoryCity: this.relatoryCity,
        activeActivitiesFilter: this.activeActivitiesFilter,
        starsFilter: this.starsFilter,
      });
      this.$router.push(
        `/relatorio/${this.relatoryKeepingSector.keepingSectorId}`
      );
    },
    redirect(user) {
      if (user.id) {
        let route = this.$router.resolve({
          path: `/desempenho-zelador/${user.id}`,
        });
        window.open(route.href, "_blank");
      }
    },
    filterByActivity(activities) {
      this.$emit("filter-by-activity", activities);
      this.$store.commit("map/removeAllTags");
      this.filteredActivities = activities;
      this.activitiesActiveCount = this.filteredActivities.filter(
        (activity) => activity.active
      ).length;
      this.filterModal = false;
    },
    receiveClickPin(pin) {
      this.$refs.activitiesPhotos.openModalByPinClick(pin);
    },
  },
};
</script>

<style lang="scss" scoped>
.subtitle {
  text-align: left;
  margin-bottom: 4px;

  .subtitle-neighborhood {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    color: #29334e;
  }

  .subtitle-keeping {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #565e73;
  }
}

.map-info {
  width: 100%;
  margin-left: 16px;
  padding-right: 18px;
  margin-top: 32px;

  .map-info-container {
    display: flex;
    gap: 8px;

    .map-width-reduced {
      width: 50%;
      margin-right: 8px;
    }

    .map-width-full {
      width: 100%;
      margin-right: 8px;
    }

    .map-info-box {
      border: 1px solid #c6c9d0;
      border-radius: 16px;
      padding: 21px 24px 21px 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}

.map-info-counters {
  .map-info-text {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.014em;
    color: #838998;
  }

  .map-info-counter {
    font-family: "OpenSans-Regular";
    font-weight: 400;
    font-size: 18px;
    line-height: 32px;
    color: #131e3b;
  }
}

.dates-info {
  padding: 18px;

  .dates-info__activity {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #131e3b;
  }

  .dates-info__time {
    font-family: "OpenSans-Regular";
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: #565e73;
    margin-top: 4px;
  }
}

.date-info {
  margin: 0px 12px 0px 16px;
  border-top: 1px solid #dddee3;
  border-bottom: 1px solid #dddee3;
  padding-top: 32px;
  padding-bottom: 32px;
}

.user-details {
  font-family: "OpenSans-Regular";
  font-weight: 400;
  font-size: 14px;
  line-height: 156%;
  color: #565e73;
  margin-left: 12px;
  margin-bottom: 2px;
}

.hover-user {
  color: #00b1eb;
  &:hover {
    opacity: 0.8;
  }
}

.cycles-container {
  margin-top: 32px;
  margin-bottom: 32px;
  margin-left: 16px;
  margin-right: 23px;
}

.absolute-box {
  position: absolute;
  z-index: 10;
  top: 214px;
  left: 90px;
}

.calendar-box {
  position: absolute;
  z-index: 10;
  top: 224px;
  left: 142px;
}

.user-icon {
  margin-left: 6px;
  margin-bottom: 3px;
}

.filter-map {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 32px;
  margin-left: 16px;
  margin-right: 12px;

  .switch-style {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
  }

  .switch-label {
    font-family: "OpenSans-Regular";
    font-weight: 600;
    font-size: 12px;
    line-height: 156%;
    text-align: center;
    color: #838998;
    padding-top: 8px;
    margin-left: 8px;
  }
}

.activities-counter {
  font-family: "OpenSans-Regular";
  font-weight: 400;
  font-size: 14px;
  line-height: 156%;
  color: #838998;
}

.img-circle {
  border: 1px solid #bde6ff;
  border-radius: 50%;
  padding: 12px;
  width: 35px;
  height: 35px;
  margin: 0 auto;
}

.send-button {
  font-family: "OpenSans-Regular";
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  padding: 8px 24px;
  background: #003063;
  border-radius: 8px;
  margin: 0px 8px;
  outline: none;
  border: none;

  &:hover {
    background: #002a5a;
  }

  &:active {
    background: #002a5a;
  }
}

.input-checkbox {
  accent-color: #003366;
}

.cancel-button {
  font-family: "OpenSans-Regular";
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #565e73;
  margin: 0px 8px;
  padding: 8px 24px;
  background: #ffffff;
  border: 1px solid #dddee3;
  border-radius: 8px;

  &:hover {
    background: #f5f5f5;
  }

  &:active {
    background: #e5e5e5;
  }
}

.icon-delay {
  margin-left: 2px;
}

.separator-calendar {
  border: 1px solid #ececec;
  width: 85%;
  margin-top: 0;
}

.star-filter {
  position: absolute;
  z-index: 10;
  padding: 20px;
  box-shadow: 0px 4px 4px rgba(160, 168, 189, 0.24);
  background-color: #fff;
  border-radius: 8px !important;
  width: 240px;
  top: 224px;
  left: 52px;

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .list-tags {
    overflow-y: auto;
    max-height: 120px;
  }

  .checkbox-label {
    font-family: "OpenSans-Regular";
    font-size: 14px;
    color: #747474;
  }

  .checkbox-title {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: -0.014em;
    color: #29334e;
  }

  .star-close {
    margin-top: 5px !important;
    margin-right: 2px !important;
  }

  .pointer {
    font-weight: bold;
    margin: 0 5px;
  }
}

.list-container {
  margin-left: 8px;
  margin-right: 6px;
  margin-top: 16px;
}

.filter-enter-active {
  animation: filter-in 0.3s;
}

.filter-leave-active {
  animation: filter-in 0.3s reverse;
}

@keyframes filter-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(1);
  }
}
</style>
